import axios from 'axios';
//const SERVER_URL = "http://localhost:8000";
const SERVER_URL = "https://casaduana-ybr2bgi7.on-forge.com";

const fallo_token = {
    success: false,
    data:{
        status: 5
    }
}

const omitir_token = {
    success: true,
    data:{
        status: 10
    }
}

export const mail_registro_confirmacion = async (data) => {

        const ENDPOINT = `${SERVER_URL}/api/registrar`;
        try {
            let response = await axios.post(ENDPOINT,data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if(response.data.success){
                return response.data;
            }else{
                return fallo_token;
            }
            
        } catch(e){
            
            return fallo_token.data;
        }
    
}


export const existe_empresa = async (data) => {

    const ENDPOINT = `${SERVER_URL}/api/existe-empresa`;
    try {
        let response = await axios.post(ENDPOINT,data, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if(response.data.success){
            return response.data;
        }else{
            return fallo_token;
        }
        
    } catch(e){
        
        return fallo_token.data;
    }

}

export const get_token_resgistro = async (data) => {
    const ENDPOINT = `${SERVER_URL}/webinar/buscar-usuario`;
        try {
            let response = await axios.post(ENDPOINT,data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            return response.data;
            
        } catch(e){
            
            return fallo_token.data;
        }
}

export const responder_encuesta = async (nombre_evento, token, folio, data) => {
    const ENDPOINT = `${SERVER_URL}/api/webinar/diploma/${nombre_evento}/${token}/${folio}`;
        try {
            let response = await axios.post(ENDPOINT,data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if(response.data.success){
                return response.data;
            }else{
                return fallo_token;
            }
            
        } catch(e){
            
            return fallo_token.data;
        }
}

export const existe_mail = async (correo) => {

    const ENDPOINT = `${SERVER_URL}/api/existe-mail/reunion-anual-2023/${correo}`;
    try {
        let response = await axios.get(ENDPOINT,{
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if(response.data.success){
            return response.data;
        }else{
            return fallo_token;
        }
        
    } catch(e){
        
        return fallo_token.data;
    }

}


export const existe_crear_mail = async (correo) => {

    const ENDPOINT = `${SERVER_URL}/api/existes-mail/${correo}`;
    try {
        let response = await axios.get(ENDPOINT,{
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if(response.data.success){
            return response.data;
        }else{
            return fallo_token;
        }
        
    } catch(e){
        
        return fallo_token.data;
    }

}

export const networking = async () => {

    const ENDPOINT = `${SERVER_URL}/api/networking`;
    try {
        let response = await axios.get(ENDPOINT,{
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if(response.data.success){
            return response.data;
        }else{
            return fallo_token;
        }
        
    } catch(e){
        
        return fallo_token.data;
    }

}
export const permitir_entrada = async (data) => {
    const ENDPOINT = `${SERVER_URL}/api/permitir-entrada`;
        try {
            let response = await axios.post(ENDPOINT,data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if(response.data.success){
                return response.data;
            }else{
                return fallo_token;
            }
        } catch(e){
            
            return fallo_token.data;
        }
}